import _ from 'lodash';

import DataOption from '../../models/DataOption';
import StatMessages from '../../StatMessages';

export default class CallQueue {
  constructor(intl) {
    if (!intl) {
      throw Error('Missing intl param');
    }

    const statMessages = new StatMessages(intl);

    /**
         * add socket subscriptions and events if any
         * Example Props
         * stat: 'AC'
         * socketSubscriptions: [{ type: 'agent' }]
         * socketEvents: [{ name: string, adapter: function, adapterParams: object }] }
         * @type {*[]}
         */
    const stats = [
      {
        stat: 'activecall_count',
        adapterParams: {
          stat: 'activecall_count',
        },
        socketEvents: [
          {
            name: 'queue',
            adapter: 'queueSocketToSDPAdapter',
            adapterParams: {
              stat: 'gau_session',
            },
          },
        ],
        socketSubscriptions: [{ type: 'queue', unit: 'seconds' }],
        filterCategories: ['callqueue'],
        filterMultiples: false,
        ...statMessages.messages.ActiveCalls,
      },
      {
        stat: 'queuedcall_count',
        adapterParams: {
          stat: 'queuedcall_count',
        },
        socketEvents: [
          {
            name: 'queue',
            adapter: 'queueSocketToSDPAdapter',
            adapterParams: {
              stat: 'gau_queue_length',
            },
          },
        ],
        socketSubscriptions: [{ type: 'queue', unit: 'seconds' }],
        filterCategories: ['callqueue'],
        filterMultiples: false,
        ...statMessages.messages.CallsWaiting,
      },
      {
        stat: 'gau_queue_max_wait',
        adapterParams: {
          stat: 'gau_queue_max_wait',
        },
        defaultFormatType: 'time',
        socketEvents: [
          {
            name: 'queue',
            adapter: 'queueSocketToSDPAdapter',
            adapterParams: {
              stat: 'gau_queue_max_wait',
            },
          },
        ],
        socketSubscriptions: [{ type: 'queue', unit: 'seconds' }],
        filterCategories: ['callqueue'],
        filterMultiples: false,
        ...statMessages.messages.LongestWait,
      },
      {
        stat: 'agent_count',
        adapterParams: {
          stat: 'agent_count',
        },
        socketEvents: [
          {
            name: 'queue',
            adapter: 'queueSocketToSDPAdapter',
            adapterParams: {
              stat: 'gau_agent_logged_in',
            },
          },
        ],
        socketSubscriptions: [{ type: 'queue', unit: 'seconds' }],
        filterCategories: ['callqueue'],
        filterMultiples: false,
        ...statMessages.messages.AgentsOnline,
      },
      {
        stat: 'agent_available_count',
        adapterParams: {
          stat: 'agent_available_count',
        },
        socketEvents: [
          {
            name: 'queue',
            adapter: 'queueSocketToSDPAdapter',
            adapterParams: {
              stat: 'gau_agent_available',
            },
          },
        ],
        socketSubscriptions: [{ type: 'queue', unit: 'seconds' }],
        filterCategories: ['callqueue'],
        filterMultiples: false,
        ...statMessages.messages.AgentsIdle,
      },
    ];

    /**
         * @type {DataOption[]}
         */
    const options = stats.map((stat) => new DataOption({
      type: 'socket',
      hasCategories: false,
      hasColumns: false,
      supportedCharts: ['ResponsiveStat'],
      unit: 'seconds',
      ...stat,
    }));

    this.dataOptions = _.keyBy(options, 'stat');
  }
}
